import { render, staticRenderFns } from "./LabelTooltip.vue?vue&type=template&id=635f204c&scoped=true&"
import script from "./LabelTooltip.vue?vue&type=script&lang=js&"
export * from "./LabelTooltip.vue?vue&type=script&lang=js&"
import style0 from "./LabelTooltip.vue?vue&type=style&index=0&id=635f204c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635f204c",
  null
  
)

export default component.exports